/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One synced Okta application instance that maps to the suggested server.
 */
export type OktaServerSuggestionApplication = {
  /**
   * Live group assignments.
   */
  groupAssignments: number;
  /**
   * Admin-facing label. Admin-editable; never a key.
   */
  label: string;
  /**
   * Okta application template name; the key that matched the catalog entry.
   */
  name: string;
  /**
   * Okta application id.
   */
  oktaAppId: string;
  signOnMode: string;
  /**
   * Live direct and group-derived user assignments.
   */
  userAssignments: number;
  /**
   * Whether this instance's sign-on mode supports Cross App Access. False for password-vault (SWA) and bookmark instances.
   */
  xaaSupported: boolean;
};

/** @internal */
export const OktaServerSuggestionApplication$inboundSchema: z.ZodMiniType<
  OktaServerSuggestionApplication,
  unknown
> = z.pipe(
  z.object({
    group_assignments: z.int(),
    label: z.string(),
    name: z.string(),
    okta_app_id: z.string(),
    sign_on_mode: z.string(),
    user_assignments: z.int(),
    xaa_supported: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "group_assignments": "groupAssignments",
      "okta_app_id": "oktaAppId",
      "sign_on_mode": "signOnMode",
      "user_assignments": "userAssignments",
      "xaa_supported": "xaaSupported",
    });
  }),
);

export function oktaServerSuggestionApplicationFromJSON(
  jsonString: string,
): SafeParseResult<OktaServerSuggestionApplication, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OktaServerSuggestionApplication$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OktaServerSuggestionApplication' from JSON`,
  );
}
